module.exports = __webpack_public_path__ + "media/marketplace_fund/deck-preview-5-thumb-8d74470d.png";